'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@svenskaspelab/ui/react/button';
import type { ComponentProps, ReactNode } from 'react';
type DownloadExternalFileProps = ComponentProps<typeof Button> & {
  rows: string[];
  fileName: string;
};

/**
 * Client component for downloading external system file.
 *
 * @param root0 component props
 * @param root0.rows row data to write to file
 * @param root0.fileName output filename
 * @param root0.children optional button content
 * @param root0.onClick incoming button click handler
 * @param root0.props forwarded button props, including ref
 * @returns download button
 */
export function DownloadExternalFile(t0) {
  const $ = _c(16);
  let children;
  let fileName;
  let onClick;
  let props;
  let rows;
  if ($[0] !== t0) {
    ({
      rows,
      fileName,
      children,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = fileName;
    $[3] = onClick;
    $[4] = props;
    $[5] = rows;
  } else {
    children = $[1];
    fileName = $[2];
    onClick = $[3];
    props = $[4];
    rows = $[5];
  }
  let t1;
  if ($[6] !== fileName || $[7] !== rows) {
    t1 = () => {
      if (rows.length === 0) {
        return;
      }
      const content = rows.join("\r\n");
      const base64Rows = window.btoa(content);
      const link = document.createElement("a");
      link.href = `data:application/octet-stream;charset:UTF-8;base64,${base64Rows}`;
      link.download = fileName;
      link.click();
    };
    $[6] = fileName;
    $[7] = rows;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleClick = t1;
  let t2;
  if ($[9] !== handleClick || $[10] !== onClick) {
    t2 = event => {
      onClick?.(event);
      if (!event.defaultPrevented) {
        handleClick();
      }
    };
    $[9] = handleClick;
    $[10] = onClick;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = children ?? "Ladda ned fil";
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Button variant="ghost" {...props} onClick={t2}>{t3}</Button>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}